export const Pinned = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clip-path="url(#clip0_2480_14927)">
      <path
        d="M12.5596 5.37804C12.6416 5.296 12.6876 5.18476 12.6876 5.06878C12.6876 4.9528 12.6416 4.84156 12.5596 4.75952L9.24223 1.44054C9.16019 1.35855 9.04895 1.3125 8.93297 1.3125C8.81699 1.3125 8.70575 1.35855 8.62371 1.44054L5.49012 4.58288C5.49012 4.58288 3.97254 3.82437 2.3516 5.13249C2.30354 5.17097 2.26413 5.21915 2.23596 5.2739C2.2078 5.32865 2.19151 5.38873 2.18815 5.45021C2.18479 5.51168 2.19445 5.57318 2.21649 5.63067C2.23853 5.68815 2.27246 5.74034 2.31606 5.78382L8.21684 11.6841C8.26103 11.7279 8.31408 11.7619 8.37244 11.7836C8.4308 11.8053 8.49312 11.8143 8.55524 11.81C8.61737 11.8057 8.67786 11.7882 8.73267 11.7587C8.78748 11.7291 8.83535 11.6882 8.87309 11.6387C9.33191 11.0284 10.0527 9.77437 9.42598 8.52148L12.5596 5.37804Z"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.26586 8.73438L2.625 11.3752"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2480_14927">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
